import { BaseApi } from "../base.js";
import { API } from "../constants.js";
import { reloadBalances } from "@/api/coinService";

export class ExchangeApi extends BaseApi {
  getPairs(options = {}) {
    return this.request(
      () => this.r.get(`${API.EMCD_API2}/exchange/pairs`, {}, options),
      (d) => {
        this.coins.setFlagForAvailableExchange(d.data);
        this.exchange.setPairs(d.data);
      },
    );
  }

  getLimits(options = {}) {
    const pair = this._pair();
    return this.request(
      () =>
        this.r.get(`${API.EMCD_API}/exchange/limit/${pair.id}`, {}, options),
      (d) => this.exchange.setLimits(pair, d.data),
    );
  }

  getRate(options = {}) {
    const pair = this.exchange.limits.pair;
    const [base] = pair.id.split("-");
    const payload = {
      amount: {},
      direction:
        base === this.exchange.form.from.coin.config.id ? "sell" : "buy",
      promo_code: "",
    };

    if (payload.direction === "sell") {
      payload.amount.base = this.exchange.form.from.amount;
    } else {
      payload.amount.quote = this.exchange.form.from.amount;
    }

    return this.request(
      () =>
        this.r.post(
          `${API.EMCD_API}/exchange/rate/${pair.id}`,
          payload,
          {},
          options,
        ),
      (result) => {
        this.exchange.setCalculated(payload.direction, result.data);
      },
    );
  }

  order() {
    const pair = this._pair();
    return this.request(
      () =>
        this.r.post(`${API.EMCD_API}/exchange/order/${pair.id}`, {
          "Content-Type": "",
        }),
      () => reloadBalances(),
    );
  }

  _pair() {
    const from = this.exchange.form.from.coin.config.id;
    const to = this.exchange.form.to.coin.config.id;
    return this.exchange.pairs.find(
      (p) => p.id.includes(from) && p.id.includes(to),
    );
  }
}
